import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {Shell} from '@app/shell';
import {physicianGuard} from '@app/auth/guards/physician.guard';
import {EuComponent} from '@modules/eu/pages/eu/eu.component';
import {pharmacistGuard} from '@app/auth/guards/pharmacist.guard';
import {CountryComponent} from '@modules/eu/country/pages/country/country.component';
import {patientRoutes} from '@modules/eu/country/patient/patient-routing.module';
import {physicianPharmacistGuard} from '@app/auth/guards/physician-pharmacist.guard';

export const countryRoutes: Routes = [
  {
    path: '',
    canActivate: [physicianPharmacistGuard],
    component: EuComponent,
  },
  {
    path: ':country',
    canActivate: [physicianPharmacistGuard],
    children: patientRoutes,
  },

];

@NgModule({
  imports: [RouterModule.forChild(countryRoutes)],
  exports: [RouterModule]
})
export class CountryRoutingModule { }
